import React from 'react';
import { formatCedi, formatDateTime } from '../utils/formatters';
import { methodLabels } from '../utils/constants';
import { getAmendmentHistory } from '../utils/amendments';

const methodName = (method) => (method ? methodLabels[method] || method : 'None');

// Audit trail of every amendment on an order: who, when, why, and what changed.
export default function AmendmentHistory({ order }) {
  const history = getAmendmentHistory(order);
  if (history.length === 0) return null;

  return (
    <div className="bg-amber-50 rounded-lg p-4">
      <h4 className="font-semibold text-amber-800 mb-3">Amendment history</h4>
      <div className="space-y-3">
        {history.map((entry, idx) => (
          <div key={`${entry.at}-${idx}`} className="border-l-2 border-amber-400 pl-3 space-y-1">
            <div className="flex flex-wrap items-baseline justify-between gap-x-3">
              <span className="text-sm font-semibold text-gray-800">{entry.by}</span>
              <span className="text-xs text-gray-600">{formatDateTime(entry.at)}</span>
            </div>
            <div className="text-sm text-gray-800">
              <span className="text-gray-600">Reason:</span> {entry.reason || <em className="text-gray-500">none given</em>}
            </div>
            {entry.itemChanges.length > 0 && (
              <ul className="text-xs text-gray-700 space-y-0.5">
                {entry.itemChanges.map((row) => (
                  <li key={row.name}>
                    {row.to === 0 ? 'Removed' : row.from === 0 ? 'Added' : 'Changed'} {row.name}: {row.from} → {row.to}
                  </li>
                ))}
              </ul>
            )}
            {entry.paymentChange && (
              <div className="text-xs text-gray-700">
                Payment: {methodName(entry.paymentChange.from)} → {methodName(entry.paymentChange.to)}
              </div>
            )}
            {entry.detailChanges.map((change) => (
              <div key={change.label} className="text-xs text-gray-700">
                {change.label}: {change.from || '—'} → {change.to || '—'}
              </div>
            ))}
            <div className="text-xs text-gray-700">
              Total: {formatCedi(entry.originalTotal)} → {formatCedi(entry.newTotal)}
              {entry.diffAmount !== 0 && (
                <span className={entry.diffAmount > 0 ? 'text-red-700' : 'text-emerald-700'}>
                  {' '}({entry.diffAmount > 0 ? '+' : '−'}{formatCedi(Math.abs(entry.diffAmount))})
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
